<template>
  <!-- Hoja de servicio: rango con avatar, avance al siguiente, las TRES
       condiciones que mueven la escalera, y el escalafón completo.
       Renderizador puro: TODO llega formateado del servidor (el monto y la
       etiqueta de la ventana incluidos). -->
  <section class="credit-stats" :class="{ 'credit-stats--frozen': data.frozen }">
    <div class="credit-stats__title">{{ $t('credits.stats_title') }}</div>

    <div class="credit-stats__identity">
      <img :src="data.avatar_url" alt="" class="credit-stats__avatar">
      <div class="credit-stats__identity-body">
        <div class="credit-stats__rank">{{ data.level_name || $t('credits.level_default') }}</div>
        <div class="credit-stats__foot">
          <template v-if="data.level < data.max_level && data.next_level_name">
            {{ $t('credits.next_level', { name: data.next_level_name }) }}<!--
            El modal vive FUERA del arcadi-card (su backdrop-filter atraparía la
            máscara), así que el disparador es un label que apunta al checkbox
            de allá; el JS de créditos le da Enter/Espacio y ESC.
         --><label v-if="data.has_next_rank" :for="data.rankup_toggle_id"
                   class="credit-stats__rankup material-icons-sharp"
                   role="button" tabindex="0" data-credits-modal-trigger
                   :aria-label="$t('credits.rank_up_trigger')">info</label>
          </template>
          <template v-else>{{ $t('credits.max_level') }}</template>
        </div>
      </div>
    </div>

    <!-- Qué habilita el rango. Llega armado del servidor: lleva un monto.
         Debajo del avatar, a todo el ancho — no apretado en la columna. -->
    <div v-if="data.rank_blurb" class="credit-stats__blurb"><credit-money-text :text="data.rank_blurb" /></div>

    <!-- Icono y estado arriba; etiqueta, valor y avance usan todo el ancho. -->
    <div class="credit-stats__sheet">
      <h3 v-if="data.has_next_rank" class="credit-stats__sheet-title">
        {{ $t('credits.conditions_title') }}
      </h3>
      <div class="credit-stats__row">
        <span class="material-icons-sharp credit-stats__row-icon" aria-hidden="true">calendar_month</span>
        <div class="credit-stats__row-main">
          <div class="credit-stats__row-label">{{ $t('credits.stats_history') }}</div>
          <div class="credit-stats__row-value"
               :class="{ 'credit-stats__row-value--empty': data.history_months == null }">
            {{ data.history_months != null ? data.history_months : $t('credits.stats_volume_empty') }}<span v-if="meta('history')" class="credit-stats__row-goal"> / {{ meta('history').target }}</span>
          </div>
          <div class="credit-stats__row-note">{{ $t('credits.stats_history_note') }}</div>
          <span v-if="meta('history')" class="credit-stats__row-bar">
            <span class="credit-stats__row-fill"
                  :class="{ 'credit-stats__row-fill--ok': estado('history') === 'ok' }"
                  :style="{ width: meta('history').pct + '%' }"></span>
          </span>
        </div>
        <span v-if="estado('history')" class="material-icons-sharp credit-stats__row-check"
              :class="'credit-stats__row-check--' + estado('history')"
              aria-hidden="true">check</span>
      </div>
      <div class="credit-stats__row">
        <span class="material-icons-sharp credit-stats__row-icon" aria-hidden="true">verified</span>
        <div class="credit-stats__row-main">
          <div class="credit-stats__row-label">{{ $t('credits.stats_punctual') }}</div>
          <div class="credit-stats__row-value">
            {{ data.punctual_loans }}<span v-if="meta('punctual')" class="credit-stats__row-goal"> / {{ meta('punctual').target }}</span>
          </div>
          <span v-if="meta('punctual')" class="credit-stats__row-bar">
            <span class="credit-stats__row-fill"
                  :class="{ 'credit-stats__row-fill--ok': estado('punctual') === 'ok' }"
                  :style="{ width: meta('punctual').pct + '%' }"></span>
          </span>
        </div>
        <span v-if="estado('punctual')" class="material-icons-sharp credit-stats__row-check"
              :class="'credit-stats__row-check--' + estado('punctual')"
              aria-hidden="true">check</span>
      </div>
      <div class="credit-stats__row">
        <span class="material-icons-sharp credit-stats__row-icon" aria-hidden="true">insights</span>
        <div class="credit-stats__row-main">
          <div class="credit-stats__row-label">{{ $t('credits.stats_volume') }}</div>
          <div class="credit-stats__row-value"
               :class="{ 'credit-stats__row-value--empty': !data.avg_spend }">
            <credit-money-text :text="data.avg_spend || $t('credits.stats_volume_empty')" /><span v-if="meta('spend')" class="credit-stats__row-goal"> / <credit-money-text :text="meta('spend').target" /></span>
          </div>
          <div v-if="data.spend_window_label" class="credit-stats__row-note">{{ data.spend_window_label }}</div>
          <span v-if="meta('spend')" class="credit-stats__row-bar">
            <span class="credit-stats__row-fill"
                  :class="{ 'credit-stats__row-fill--ok': estado('spend') === 'ok' }"
                  :style="{ width: meta('spend').pct + '%' }"></span>
          </span>
        </div>
        <span v-if="estado('spend')" class="material-icons-sharp credit-stats__row-check"
              :class="'credit-stats__row-check--' + estado('spend')"
              aria-hidden="true">check</span>
      </div>
    </div>

    <div v-if="data.ranks && data.ranks.length" class="credit-stats__ranks">
      <div class="credit-stats__ranks-title">{{ $t('credits.ranks_title') }}</div>
      <ol class="credit-stats__ranks-list hide-scrollbar">
        <li v-for="r in data.ranks" :key="r.level"
            class="credit-stats__rank-item"
            :class="{ 'credit-stats__rank-item--locked': !r.reached,
                      'credit-stats__rank-item--current': r.level === data.level }">
          <component :is="rankToggle(r) ? 'label' : 'span'"
                     :for="rankToggle(r)"
                     :role="rankToggle(r) ? 'button' : null"
                     :tabindex="rankToggle(r) ? 0 : null"
                     :data-credits-modal-trigger="rankToggle(r) ? '' : null"
                     :aria-label="rankToggle(r) ? r.name + ': ' + $t(r.level === data.level ? 'credits.current_rank_trigger' : 'credits.rank_up_trigger') : null"
                     class="credit-stats__rank-content"
                     :class="{ 'credit-stats__rank-content--trigger': rankToggle(r) }">
            <span class="credit-stats__rank-avatar-wrap">
              <img :src="r.avatar_url" alt="" class="credit-stats__rank-avatar">
              <span v-if="!r.reached" class="material-icons-sharp credit-stats__rank-lock"
                    aria-hidden="true">lock</span>
              <span v-if="!r.reached" class="credit-stats__rank-state">{{ $t('credits.rank_locked') }}</span>
            </span>
            <span class="credit-stats__rank-tag">
              <span class="credit-stats__rank-name">{{ r.name }}</span>
              <span v-if="r.max_amount" class="credit-stats__rank-max"><credit-money-text :text="r.max_amount" abbreviated /></span>
            </span>
          </component>
        </li>
      </ol>
    </div>
  </section>
</template>

<script>
import CreditMoneyText from './credit-money-text.vue';
// Reemplaza a la barra suelta de nivel (2026-08-27): el rango, su avatar y
// las estadísticas viven en un solo contenedor, y la escalera de cupos queda
// en el suyo.
export default {
  name: 'CreditLevelProgress',
  components: { CreditMoneyText },
  props: { data: { type: Object, required: true } },
  methods: {
    rankToggle (rank) {
      return rank.toggle_id || null
    },
    // La meta se muestra SIEMPRE que exista, cumplida o no: las tres filas se
    // leen igual ("0 / 0", "2 / 2") y el umbral no desaparece justo cuando el
    // usuario quiere confirmar que lo alcanzó. En el rango máximo el servidor
    // manda `requisitos` en null y no hay meta que mostrar.
    meta (clave) {
      return (this.data.requisitos && this.data.requisitos[clave]) || null
    },
    // 'ok' cumplida, 'pending' pendiente, null cuando no hay umbral que
    // cumplir (rango máximo): ahí no corresponde ninguna tilde.
    estado (clave) {
      const r = this.data.requisitos && this.data.requisitos[clave]
      if (!r) return null
      return r.met ? 'ok' : 'pending'
    }
  }
}
</script>
